// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"47896afc","453":"cd62250c","455":"875b8ee9","977":"614245a9"}[chunkId] + ".chunk.js";
};